import React from 'react';
import { Tabs, Tab } from '@mui/material';

const CustomTabs = ({ tabValue, onChange, isRole }) => {
  console.log('isRole', isRole);

  return (
    <Tabs
      value={tabValue}
      onChange={onChange}
      indicatorColor=''
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile>
      <Tab
        label="All Users"
        sx={{
          textTransform: "capitalize",
          fontFamily: "Outfit",
          fontSize: '16px',
          backgroundColor: tabValue === 0 ? "transparent" : "transparent",
          borderRadius: "5px 5px 0px 0px",
          color: tabValue === 0 ? "rgba(0, 151, 178, 1)" : "inherit",
          "&:hover": {
            backgroundColor: tabValue === 0 ? "transparent" : "transparent",
          },
        }}
      />
      {(isRole == null || isRole == 2) && <Tab
        label="Pending Request"
        sx={{
          textTransform: "capitalize",
          fontFamily: "Outfit",
          fontSize: '16px',
          backgroundColor: tabValue === 0 ? "transparent" : "transparent",
          borderRadius: "5px 5px 0px 0px",
          color: tabValue === 1 ? "rgba(0, 151, 178, 1)" : "inherit",
          "&:hover": {
            backgroundColor: tabValue === 0 ? "transparent" : "transparent",
          },
        }}
      />}
      {(isRole == null || isRole == 2) && <Tab
        label="Rejected Request"
        sx={{
          textTransform: "capitalize",
          fontFamily: "Outfit",
          fontSize: '16px',
          backgroundColor: tabValue === 0 ? "transparent" : "transparent",
          borderRadius: "5px 5px 0px 0px",
          color: tabValue === 2 ? "rgba(0, 151, 178, 1)" : "inherit",
          "&:hover": {
            backgroundColor: tabValue === 0 ? "transparent" : "transparent",
          },
        }}
      />}
    </Tabs>
  );
};

export default CustomTabs;
